import store from "~/js/store/store";
import { gsap, Sine, Cubic } from "gsap";
import {removeTrapFocus, trapFocus} from "~/js/common/accessibility";

export default class EnlargedImage {
  constructor() {
    this.contents = document.querySelector("._enlarged_image");
    document.body.appendChild(this.contents);
    this.close = this.contents.querySelector("._close");
    this.footer = this.contents.querySelector("._footer");
    this.center = this.contents.querySelector("._center");
    this.scale = this.contents.querySelector("._scale");
    this.photos = this.contents.querySelectorAll("._photo");
    this.mousemove = this.contents.querySelector("._mousemove");

    // this.alt = this.contents.querySelector("._alt");

    this.shrink = this.contents.querySelector("._shrink");
    this.magnify = this.contents.querySelector("._magnify");
    this.per = this.contents.querySelector("._per");
    this.zoom = 1;
    this.hoge = 1;

    this.prev = this.contents.querySelector("._prev");
    this.next = this.contents.querySelector("._next");
    this.page = this.contents.querySelector("._page");

    this.enlargedImageOpen = document.querySelector(".f-enlargedImageOpen");

    this.fitScale = 1;
    this.photoNum = 0;
    this.perX = 0.5;
    this.perY = 0.5;

    this.timer;

    this.isPinch = false;
    this.isTouch = false;
    this.touchX = 0;
    this.touchY = 0;
    this.moveX = 0;
    this.moveY = 0;
    this.distance = 0;
    this.distanceX = 0;
    this.distanceY = 0;
    this.distanceX2 = 0;
    this.distanceY2 = 0;
    this.centerX = 0;
    this.centerY = 0;
    this.isSet = false;

    this.setup();
  }

  setup() {
    store.subscribe((mutation, state) => {
      if (store.getters["enlargedImage"]()) {
        gsap.to(this.contents, {
          display: "block",
          opacity: 1,
          duration: 0.1,
          ease: Cubic.easeInOut,
          onComplete: this.setContents.bind(this)
        });
        document.getElementsByTagName("body")[0].classList.add("off");
      } else {
        gsap.to(this.contents, {
          display: "none",
          opacity: 0,
          duration: 0.3,
          ease: Cubic.easeInOut,
          onComplete: this.killContents.bind(this)
        });
        document.getElementsByTagName("body")[0].classList.remove("off");
      }
    });
    this.close.addEventListener("click", (event) => {
      store.dispatch("setEnlargedImage", {
        sta: false
      });
      removeTrapFocus(this.contents)
      this.enlargedImageOpen.querySelector('.on').focus()
    });
    this.enlargedImageOpen.addEventListener("click", (event) => {
      store.dispatch("setEnlargedImage", {
        sta: true
      });
      this.photoNum = store.getters["photoNum"]();
    });

    this.contents.addEventListener('keydown', function(e) {
      if(e.key == 'Escape') {
        store.dispatch("setEnlargedImage", {
          sta: false
        });
        removeTrapFocus(this.contents)
        this.enlargedImageOpen.querySelector('.on').focus()  
      }
    });

    this.enlargedImageOpen.addEventListener("keydown", (event) => {
      if (['ENTER', 'SPACE'].includes(event.code.toUpperCase())) {
        store.dispatch("setEnlargedImage", {
          sta: true
        });
        this.photoNum = store.getters["photoNum"]();
        setTimeout(function() {
          trapFocus(document.querySelector("._enlarged_image"));
        }, 500);
      }
    });
    this.shrink.addEventListener("click", (event) => {
      if (this.zoom == 1) return;
      this.zoomImage(this.zoom - 1);
    });
    this.magnify.addEventListener("click", (event) => {
      if (this.zoom == 3) return;
      this.zoomImage(this.zoom + 1);
    });
    this.prev.addEventListener("click", (event) => {
      event.preventDefault();
      --this.photoNum;
      this.isSet = false;
      this.setContents();
    });
    this.next.addEventListener("click", (event) => {
      event.preventDefault();
      ++this.photoNum;
      this.isSet = false;
      this.setContents();
    });
    this.contents.addEventListener("click", (event) => {
      this.setTimer();
    });
    if (store.getters["isSP"]()) {
      //SP
      this.contents.addEventListener(
        "touchstart",
        (event) => {
          if (!this.isTouch) {
            this.isTouch = true;

            setTimeout(
              function () {
                this.isTouch = false;
              }.bind(this),
              350
            );
          } else {
            // ダブルタップ
            if (event.touches.length != 1) return;
            let _zoom;
            let _distanceX;
            let _distanceY;
            let _distanceX2;
            let _distanceY2;
            if (this.zoom == 1) {
              _zoom = 3;
              _distanceX = event.touches[0].pageX - this.contents.clientWidth / 2 - this.centerX;
              _distanceY = event.touches[0].pageY - this.contents.clientHeight / 2 - this.centerY;
            } else {
              _zoom = 1;
              _distanceX = 0;
              _distanceY = 0;
            }
            _distanceX2 = _distanceX / this.hoge;
            _distanceY2 = _distanceY / this.hoge;
            this.zoom = _zoom;
            gsap.to(this, {
              hoge: this.zoom,
              moveX: 0,
              moveY: 0,
              distanceX: _distanceX,
              distanceY: _distanceY,
              distanceX2: _distanceX2,
              distanceY2: _distanceY2,
              duration: 0.6,
              ease: Sine.easeOut,
              onUpdate: this.onUpdate.bind(this)
            });

            this.isTouch = false;
          }

          if (event.touches.length == 1 && !this.isPinch) {
            if (event.touches[0]) {
              this.touchX = event.touches[0].pageX;
              this.touchY = event.touches[0].pageY;
            }
          } else if (event.touches.length == 2 && !this.isPinch) {
            this.isPinch = true;
            this.distance = Math.sqrt(Math.pow(event.touches[1].pageX - event.touches[0].pageX, 2) + Math.pow(event.touches[1].pageY - event.touches[0].pageY, 2));
            this.distanceX = (event.touches[0].pageX + event.touches[1].pageX - this.contents.clientWidth) / 2 - this.centerX;
            this.distanceY = (event.touches[0].pageY + event.touches[1].pageY - this.contents.clientHeight) / 2 - this.centerY;
            this.distanceX2 = this.distanceX / this.hoge;
            this.distanceY2 = this.distanceY / this.hoge;

            this.onUpdate();
          }
        },
        {
          passive: false
        }
      );
      this.contents.addEventListener(
        "touchmove",
        (event) => {
          event.preventDefault();

          if (event.touches.length == 1 && !this.isPinch) {
            if (event.touches[0]) {
              this.moveX += event.touches[0].pageX - this.touchX;
              this.moveY += event.touches[0].pageY - this.touchY;
              this.touchX = event.touches[0].pageX;
              this.touchY = event.touches[0].pageY;
              this.onUpdate();
            }
          } else if (event.touches.length == 2) {
            let _distance = Math.sqrt(Math.pow(event.touches[1].pageX - event.touches[0].pageX, 2) + Math.pow(event.touches[1].pageY - event.touches[0].pageY, 2));
            let _zoom = (this.zoom * _distance) / this.distance;
            if (_zoom < 1) {
              _zoom = 1;
            } else if (_zoom > 3) {
              _zoom = 3;
            }
            this.pinchImage(_zoom);
            this.distance = _distance;
          }
        },
        {
          passive: false
        }
      );
      this.contents.addEventListener(
        "touchend",
        (event) => {
          if (event.touches.length == 0 && this.isPinch) {
            this.isPinch = false;
            this.moveX -= this.distanceX2 * this.hoge - this.distanceX;
            this.moveY -= this.distanceY2 * this.hoge - this.distanceY;
            this.distanceX = 0;
            this.distanceY = 0;
            this.distanceX2 = 0;
            this.distanceY2 = 0;

            this.onUpdate();
          }
        },
        {
          passive: false
        }
      );
    } else {
      //PC
      this.mousemove.addEventListener("mousemove", (event) => {
        this.perX = event.clientX / this.mousemove.clientWidth;
        this.perY = event.clientY / this.mousemove.clientHeight;
        this.onUpdate();
        this.setTimer();
      });
      this.mousemove.addEventListener("click", (event) => {
        switch (this.zoom) {
          case 1:
            this.zoomImage(2);
            break;
          case 2:
            this.zoomImage(3);
            break;
          case 3:
            this.zoomImage(1);
            break;
        }
      });
    }
  }

  setContents() {
    if(this.isSet) return;
    this.isSet = true;

    this.photos.forEach((elm, index) => {
      elm.classList.remove("on");
    });
    this.photos[this.photoNum].classList.add("on");

    // this.alt.textContent = this.photos[this.photoNum].getAttribute("alt");

    this.page.textContent = this.photoNum + 1 + "/" + this.photos.length;
    this.prev.classList.remove("off");
    this.next.classList.remove("off");
    if (this.photoNum == 0) {
      this.prev.classList.add("off");
    } else if (this.photoNum == this.photos.length - 1) {
      this.next.classList.add("off");
    }
    this.fitScale = Math.min(this.contents.clientWidth / this.photos[this.photoNum].getAttribute('width'), this.contents.clientHeight / this.photos[this.photoNum].getAttribute('height'));
    //リセット
    this.zoom = 1;
    this.hoge = this.zoom;
    this.touchX = 0;
    this.touchY = 0;
    this.moveX = 0;
    this.moveY = 0;
    this.centerX = 0;
    this.centerY = 0;
    this.shrink.classList.add("off");
    this.shrink.disabled = true;
    this.magnify.classList.remove("off");
    this.magnify.disabled = false;
    this.per.textContent = "100%";

    const _width = this.photos[this.photoNum].getAttribute('width') * this.fitScale;
    const _height = this.photos[this.photoNum].getAttribute('height') * this.fitScale;

    gsap.fromTo(
      this.photos[this.photoNum],
      {
        width: _width * 0.9,
        height: _height * 0.9,
        opacity: 0
      },
      {
        width: _width,
        height: _height,
        opacity: 1.0,
        duration: 0.6,
        ease: Cubic.easeOut
      }
    );

    this.onUpdate();
  }

  killContents() {
    if(!this.isSet) return;
    this.isSet = false;

    this.photos.forEach((elm, index) => {
      gsap.set(elm, { opacity: 0 });
    });
  }

  zoomImage(num) {
    if (this.zoom == 1 && num == 2) {
      this.perX = 0.5;
      this.perY = 0.5;
    }
    this.zoom = num;
    switch (this.zoom) {
      case 1:
        this.shrink.classList.add("off");
        this.shrink.disabled = true;
        this.magnify.classList.remove("off");
        this.magnify.disabled = false;
        this.per.textContent = "100%";
        break;
      case 2:
        this.shrink.classList.remove("off");
        this.shrink.disabled = false;
        this.magnify.classList.remove("off");
        this.magnify.disabled = false;
        this.per.textContent = "200%";
        break;
      case 3:
        this.shrink.classList.remove("off");
        this.shrink.disabled = false;
        this.magnify.classList.add("off");
        this.magnify.disabled = true;
        this.per.textContent = "300%";
        break;
    }
    gsap.to(this, {
      hoge: this.zoom,
      duration: 0.6,
      ease: Sine.easeInOut,
      onUpdate: this.onUpdate.bind(this)
    });
    gsap.to(this, {
      perX: 0.5,
      perY: 0.5,
      duration: 0.6,
      ease: Sine.easeInOut,
      onUpdate: this.onUpdate.bind(this)
    });
  }

  pinchImage(num) {
    this.zoom = num;
    this.hoge = this.zoom;
    this.onUpdate();
  }

  onUpdate() {
    if (store.getters["isSP"]()) {
      //SP
      this.centerX = this.moveX;
      this.centerY = this.moveY;
      gsap.set(this.photos[this.photoNum], { left: -this.distanceX2, top: -this.distanceY2 });
      gsap.set(this.scale, { scale: this.hoge, left: this.distanceX, top: this.distanceY });
      gsap.set(this.center, { left: this.centerX, top: this.centerY });
    } else {
      //PC
      const _imageW = this.photos[this.photoNum].getAttribute('width') * this.fitScale * this.hoge;
      const _imageH = this.photos[this.photoNum].getAttribute('height') * this.fitScale * this.hoge;
      if (this.contents.clientWidth < _imageW) {
        this.centerX = (_imageW - this.contents.clientWidth) / 2 - (_imageW - this.contents.clientWidth) * this.perX;
      }
      if (this.contents.clientHeight < _imageH) {
        this.centerY = (_imageH - this.contents.clientHeight) / 2 - (_imageH - this.contents.clientHeight) * this.perY;
      }
      gsap.set(this.scale, { scale: this.hoge });
      gsap.set(this.center, { left: this.centerX, top: this.centerY });
    }
  }

  setTimer() {
    this.footer.classList.remove("off");

    clearTimeout(this.timer);
    this.timer = setTimeout(this.setTimerComplete.bind(this), 3000);
  }
  setTimerComplete() {
    this.footer.classList.add("off");
  }
}
